import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { mainList } from './request';
import { agencyResource } from './../../insurance/organizationalManage/request';
import { applicationResource } from './../../customer/applicationManage/request';
import { mapState } from 'vuex';
import codeModel from './codeModel.vue';
export default {
  components: {
    codeModel
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  data() {
    return {
      form: {},
      data: [],
      unitList: [],
      intermediaryList: [],
      applicationList: [],
      columns: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      codeShow: false,
      dateArr: []
    };
  },
  created() {
    console.log(JSON.stringify(this.columns));
    // unitResource({}).then(res=>{
    //   this.unitList=res;
    // });
    this.agencyFun();
    this.getDataFun();
    // console.log(this.accountInfo.customerId);
    applicationResource({
      customerId: this.accountInfo.customerId
    }).then(res => {
      this.applicationList = res;
    });
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    async getDataFun() {
      const h = this.$createElement;
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      const res = await mainList(obj);
      if (res.fieldConfig) {
        this.columns = res.fieldConfig.map(item => {
          let obj = item;
          item.slots = {
            title: item.title
          };
          delete obj.title;
          if (item.ellipsis) {
            obj.customRender = text => h("a-tooltip", {
              "attrs": {
                "placement": "topLeft",
                "title": text
              }
            }, [text]);
          }
          return obj;
        });
        this.columns.push({
          slots: {
            title: '操作'
          },
          width: 280,
          key: '6',
          align: 'center',
          scopedSlots: {
            customRender: 'action'
          }
        });
      }
      this.pagination.total = res.totalNum;
      this.data = res.items;
    },
    async agencyFun() {
      this.intermediaryList = await agencyResource({});
    },
    agencyChange(val) {
      console.log();
      let arr = this.intermediaryList.filter(item => item.id == val);
      this.form.unitId = arr.length != 0 ? arr[0].unitId : undefined;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleCode() {
      this.codeShow = true;
      this.$nextTick(() => {
        this.$refs.codeRef.init();
      });
    },
    onChange(date) {
      if (date.length != 0) {
        this.form.startAt = date[0];
        this.form.endAt = date[1];
      } else {
        this.form.startAt = '';
        this.form.endAt = '';
      }
    }
  }
};